module.exports = __webpack_public_path__ + "static/media/netesnaf.d67672c7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/netesnaf.svg
// module id = 184
// module chunks = 0